import React from 'react'
import './Chats.css'
import Chat from './Chat'

const Chats = () => {
    return (
        <div className='chats'>
            <Chat
                name='Vitalik'
                message='tomorrow is not today'
                timestamp='45 minutes ago'
                profilePic='https://tk.media/storage/uploads/articles/0/871-article20190827105858.jpg'
            />
            <Chat
                name='Tolik'
                message='Many oil!'
                timestamp='15 minutes ago'
                profilePic='https://i.ytimg.com/vi/lX45OcBk7XA/maxresdefault.jpg'
            />
            <Chat
                name='Vovka'
                message='I give you 10 tickets :)'
                timestamp='5 days ago'
                profilePic='https://img.pravda.com/images/doc/6/a/6a2750b-img-1987-res.jpg'
            />
            <Chat
                name='Masha'
                message='Come to me...'
                timestamp='1 minutes ago'
                profilePic='https://images.crafta.ua/avatars/48562068?1538298504'
            />
        </div>
    )
}

export default Chats